import { useLocation } from "react-router-dom";

/** Map URL path -> module id used in Trend Analyzer header. */
export function useModuleContext() {
  const loc = useLocation();
  const p = loc.pathname;
  if (p === "/" || p.startsWith("/overview")) return "overview";
  if (p.startsWith("/control")) return "control";
  if (p.startsWith("/identity")) return "identity";
  if (p.startsWith("/soc")) return "soc";
  if (p.startsWith("/firewall")) return "firewall";
  if (p.startsWith("/webgw")) return "webgw";
  if (p.startsWith("/vuln")) return "vuln";
  if (p.startsWith("/email")) return "email";
  if (p.startsWith("/aisec")) return "aisec";
  if (p.startsWith("/cloud")) return "cloud";
  if (p.startsWith("/assets")) return "assetmgmt";
  if (p.startsWith("/projects")) return "projects";
  if (p.startsWith("/support")) return "support";
  if (p.startsWith("/drill")) return "drill";
  return "app";
}

/** Sniff a widget's unit from its value string. */
export function inferUnit(value) {
  if (value == null) return "count";
  const s = String(value);
  if (s.includes("%")) return "percent";
  if (/[$₹€£]/.test(s)) return "currency";
  if (/\b(min|mins|hr|hrs|hour|sec|day|days)\b/i.test(s)) return "duration";
  return "count";
}

/** Extract a numeric value from a value that might be a string like "5.2 hrs" or "$2.4M". */
export function extractNumeric(value) {
  if (typeof value === "number") return value;
  if (value == null) return 0;
  const s = String(value);
  const nm = s.match(/(-?[\d,]*\.?\d+)/);
  if (!nm) return 0;
  let n = parseFloat(nm[1].replace(/,/g, ""));
  if (!Number.isFinite(n)) return 0;
  // Only apply K / M / B magnitude if suffix is a standalone letter
  // (i.e. NOT followed by another letter — so "42 min" is NOT 42 million).
  const mag = s.match(/(-?[\d,]*\.?\d+)\s*(K|M|B)(?![a-zA-Z])/i);
  if (mag) {
    const u = mag[2].toUpperCase();
    if (u === "K") n *= 1_000;
    else if (u === "M") n *= 1_000_000;
    else if (u === "B") n *= 1_000_000_000;
  }
  return n;
}
